/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import Konva from 'konva';
import { ReactComponent as MicOffIcon } from '../images/icons/mic_off.svg';
import { ReactComponent as MicIcon } from '../images/icons/mic.svg';
import { ReactComponent as CameraIcon } from '../images/icons/camera.svg';
import { ReactComponent as CaneraOffIcon } from '../images/icons/camera_off.svg';
import { ReactComponent as ChatIcon } from '../images/icons/chat.svg';
import { ReactComponent as EndCallIcon } from '../images/icons/endcall.svg';
import { ReactComponent as VideoPreloader } from '../images/User_fill.svg';
import appStore from '../store';
import videoLoader from '../images/videoLoader.gif';
import { ReactComponent as Sound } from '../images/icons/sound.svg';

const MediaPlayer = (props) => {
  const { setShowChat, showChat, inScreenShare } = props;
  const [showSelfCam, setShowSelfCam] = useState(false);
  const [showSelfCamContainer, setShowSelfCamContainer] = useState(false);
  const [muted, setMuted] = useState(true);
  const [operatorSpeaking, setOperatorSpeaking] = useState(false);
  const [operatorAudioActive, setOperatorAudioActive] = useState(true);
  const [isOperatorCameraOff, setIsOperatorCameraOff] = useState(false);
  const [operator, setOperator] = useState(null);
  const ovdSession = appStore.useState((s) => s.ovdSession);
  const ovdSubscribers = appStore.useState((s) => s.ovdSubscribers);
  const ovdPublisher = appStore.useState((s) => s.ovdPublisher);
  const noVideoCanvas = appStore.useState((s) => s.noVideoCanvas);
  const [operatorVideo, setOperatorVideo] = useState(true);

  const SelfVideo = useRef(null);
  const IncVideo = useRef(null);

  const toggleChat = () => { setShowChat(!showChat); };

  useEffect(() => {
    console.log('ovdSubscribers', ovdSubscribers);
    if (ovdSubscribers.length > 0) {
      console.log(ovdSubscribers[0]);
      setOperator(ovdSubscribers[0]);
    }
    if (ovdPublisher) ovdPublisher.addVideoElement(SelfVideo.current);
  }, [ovdSubscribers, ovdPublisher]);

  useEffect(() => {
    console.log('operator:   ', operator);
    if (operator) {
      console.log('SET OPERATOR EVENTS');
      operator.addVideoElement(IncVideo.current);
      setOperatorVideo(operator.stream.videoActive);
      operator.on('streamPlaying', () => {
        console.log('KUKU');
        operator.on('streamPropertyChanged', (event) => {
          console.log('OPERATOR CHANGED', event);
          const { changedProperty, newValue } = event;
          switch (changedProperty) {
            case 'audioActive':
              setOperatorAudioActive(newValue);
              break;
            case 'videoActive':
              setOperatorVideo(newValue);
              break;
            default:
              break;
          }
        });
        operator.on('publisherStartSpeaking', (psevent) => {
          console.log('publisherStartSpeaking', psevent);
          setOperatorSpeaking(true);
        });
        operator.on('publisherStopSpeaking', (pstopevent) => {
          console.log('publisherStopSpeaking', pstopevent);
          setOperatorSpeaking(false);
        });
      });
    }
  }, [operator]);

  const toogleSelfCam = async (e) => {
    e.stopPropagation();
    try {
      if (!ovdPublisher) return;
      if (!showSelfCam) {
        // TODO here problem with echo
        const userStream = await navigator.mediaDevices.getUserMedia({
          audio: false,
          video: true,
        });
        const videoTracks = userStream.getVideoTracks();
        const ourVideoTrack = videoTracks[0];
        ovdPublisher.replaceTrack(ourVideoTrack);
      } else {
        const noVideoMediaTrack = noVideoCanvas.captureStream(30).getVideoTracks()[0];
        ovdPublisher.replaceTrack(noVideoMediaTrack);
      }
      // ovdPublisher.publishVideo(!showSelfCam);
      setShowSelfCamContainer(!showSelfCamContainer);
      setShowSelfCam(!showSelfCam);
      SelfVideo.current.muted = true;
    } catch (err) {
      console.log('e === ', err);
    }
  };

  const toggleMicrophone = (e) => {
    e.stopPropagation();
    if (!ovdPublisher) return;
    ovdPublisher.publishAudio(!muted);
    setMuted(!muted);
  };

  const endCall = (e) => {
    e.stopPropagation();
    if (ovdSession) ovdSession.disconnect();
  };

  useEffect(() => {
    if (operator && operator.stream.typeOfVideo !== 'CAMERA') {
      const stage = new Konva.Stage({
        container: 'container',
        width: window.innerWidth,
        height: window.innerHeight,
        draggable: true,
      });

      const getDistance = (p1, p2) => Math.sqrt((p2.x - p1.x) ** 2 + (p2.y - p1.y) ** 2);

      const getCenter = (p1, p2) => ({
        x: (p1.x + p2.x) / 2,
        y: (p1.y + p2.y) / 2,
      });
      let lastCenter = null;
      let lastDist = 0;

      stage.on('touchmove', (e) => {
        e.evt.preventDefault();
        const touch1 = e.evt.touches[0];
        const touch2 = e.evt.touches[1];

        if (touch1 && touch2) {
          if (!stage.isDragging()) {
            stage.stopDrag();
          }

          const p1 = {
            x: touch1.clientX,
            y: touch1.clientY,
          };
          const p2 = {
            x: touch2.clientX,
            y: touch2.clientY,
          };

          if (!lastCenter) {
            lastCenter = getCenter(p1, p2);
            return;
          }
          const newCenter = getCenter(p1, p2);

          const dist = getDistance(p1, p2);

          if (!lastDist) {
            lastDist = dist;
          }

          // local coordinates of center point
          const pointTo = {
            x: (newCenter.x - stage.x()) / stage.scaleX(),
            y: (newCenter.y - stage.y()) / stage.scaleX(),
          };

          const scale = stage.scaleX() * (dist / lastDist);

          stage.scaleX(scale);
          stage.scaleY(scale);

          // calculate new position of the stage
          const dx = newCenter.x - lastCenter.x;
          const dy = newCenter.y - lastCenter.y;

          const newPos = {
            x: newCenter.x - pointTo.x * scale + dx,
            y: newCenter.y - pointTo.y * scale + dy,
          };

          stage.position(newPos);

          lastDist = dist;
          lastCenter = newCenter;
        }
      });

      stage.on('touchend', () => {
        lastDist = 0;
        lastCenter = null;
      });

      const layer = new Konva.Layer();

      const image = new Konva.Image({
        image: IncVideo.current,
        draggable: true,
        width: operator.stream.videoDimensions.width,
        height: operator.stream.videoDimensions.height,
        x: 0,
        y: 0,
      });
      layer.add(image);
      stage.add(layer);
      const anim = new Konva.Animation((() => {
        // do nothing, animation just need to update the layer
      }), layer);
      anim.start();
    }
  }, [operator, window.orientation]);

  return (
    <>
      <div className={`${(operatorSpeaking ? 'media__player-operator-says' : '')} media__player-remote media__player-remote-fullscreen mobile-operator-cam ${(showChat) ? 'remote-video-small-container' : ''}`}>

        {operator && operator.stream.typeOfVideo === 'CAMERA'
          ? (
            /* eslint-disable-next-line jsx-a11y/media-has-caption */
            <video
              poster={videoLoader}
              controls={false}
              autoPlay
              loop
              width="100%"
              height="100%"
              ref={IncVideo}
              onClick={(e) => { e.preventDefault(); }}
            />
          )
          : (
            <>
              {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
              <video
                poster={videoLoader}
                controls={false}
                autoPlay
                loop
                width="100%"
                height="100%"
                ref={IncVideo}
                onClick={(e) => { e.preventDefault(); }}
                style={{ display: 'none' }}
              />
              <div id="container" />
            </>
          )}

        <div className="opertorVidoPreloader mobileOpertorVidoPreloader" style={{ opacity: !operatorVideo ? 1 : 0 }}>
          <VideoPreloader />
        </div>

        {!showChat
          && (
            <div className="mobile-operator-action">
              {operatorAudioActive && <Sound className={`mobile-operator-action__icon-stroke ${operatorSpeaking ? 'mobile-operator-action__icon-stroke_active' : ''}`} />}
              {!operatorAudioActive && <MicOffIcon className="mobile-operator-action__icon_off" />}
              {isOperatorCameraOff && <CaneraOffIcon className="mobile-operator-action__icon_off" />}
            </div>
          )}
      </div>
      <Draggable bounds="parent">
        <div
          className="mobile-media__player-self"
          style={{
            opacity: showSelfCamContainer ? 1 : 0,
          }}
        >
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video
            poster={videoLoader}
            controls={false}
            autoPlay
            loop
            muted
            width="100%"
            height="100%"
            ref={SelfVideo}
            onClick={(e) => { e.preventDefault(); }}
          />
        </div>
      </Draggable>
      {!showChat
        && (
          <div className="mobile-media__player-controls">
            {/* <Timer type="Timer" active tick={1000} /> */}
            <button type="button" className="mobile-media__player-controls-button button-red" onClick={endCall}>
              <EndCallIcon />
            </button>
            <button type="button" className="mobile-media__player-controls-button" onClick={toogleSelfCam}>
              {showSelfCam ? <CameraIcon /> : <CaneraOffIcon />}
            </button>
            <button type="button" className="mobile-media__player-controls-button" onClick={toggleMicrophone}>
              {muted ? <MicIcon /> : <MicOffIcon />}
            </button>
            <button type="button" className={`mobile-media__player-controls-button ${(showChat) && 'media__player-controls-button button-green'}`} onClick={toggleChat}>
              <ChatIcon />
            </button>
          </div>
        )}
    </>
  );
};

MediaPlayer.propTypes = {
  inScreenShare: PropTypes.bool.isRequired,
  showChat: PropTypes.bool.isRequired,
  setShowChat: PropTypes.func.isRequired,
};
export default MediaPlayer;
